export default "__VITE_ASSET__8254362c__"